'use client'

import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { useConditionFacetRefinement } from './Hooks/useConditionFacetRefinement'
import { useHandleFacetClick } from './Hooks/useHandleFacetClick.client'
import { RefinementSearchDropdown } from './MobileFilterOverlay/RefinementSearchDropdown'

export default function ConditionFilterRefinementList({
  activeConditionLabel,
  inputClassName,
}: {
  activeConditionLabel?: string
  inputClassName?: string
}) {
  const {
    searchTerm,
    selectedCondition,
    setSearchTerm,
    setSelectedCondition,
    suggestions,
  } = useConditionFacetRefinement({
    initialCondition: activeConditionLabel,
  })

  const handleFacetClick = useHandleFacetClick()

  return (
    <RefinementSearchDropdown
      inputClassName={inputClassName}
      onChange={setSearchTerm}
      onSelect={(item) => {
        handleFacetClick({
          facetType: 'condition',
          selectedValue: selectedCondition,
          setSelectedValue: setSelectedCondition,
          value: item,
        })
        trackEvent(TrackingEvents.SEARCH_LANDER_CONDITION_FILTER_CLICKED, {
          val: item,
        })
      }}
      placeholder={selectedCondition ?? 'Type Condition'}
      selectedItem={selectedCondition}
      suggestions={suggestions}
      value={searchTerm}
    />
  )
}
